import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SessionInfoSingleton } from "../data/singleton/session-info.singleton";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { catchError } from "rxjs/operators";
import { formatMessage } from "src/app/shared/utils/message.util";
import { AlertMessage } from "../constants/messages/alert-message";

/**
 * パス「/company」以下のAPIに関するクラス
 */
@Injectable({
  providedIn: "root",
})
export class CompanyApi {
  private readonly ERR_ALERT_TARGET_NAME = "会社情報";

  /**
   * コンストラクタ
   */
  constructor(
    private httpClient: HttpClient,
    private sessionInfoSingleton: SessionInfoSingleton
  ) {}

  /** GET */
  /**
   * 会社情報取得
   * - APIパス:/company/${companyId}
   * @param companyId
   * - "all"で全取得
   * @returns Observable<Object>型のレスポンス
   */
  getCompany(companyId: String): Observable<Object> {
    const url = `${environment.apiUrl}/company/${companyId}`;
    const errorMessage = formatMessage(AlertMessage.FAILED_READ_ACTION, {
      target: this.ERR_ALERT_TARGET_NAME,
    });

    return this.httpClient
      .get(url, {
        headers: new HttpHeaders({
          Authorization: this.sessionInfoSingleton.getIdToken(),
          "Content-Type": "application/json",
        }),
      })
      .pipe(
        catchError((error) => {
          alert(errorMessage);
          return error;
        })
      );
  }

  /** POST */
  /**
   * 会社情報登録
   * - APIパス:/company/company_info
   * @param params: 更新内容
   * @returns Observable<Object>型のレスポンス
   */
  createCompany(params: HttpParams): Observable<Object> {
    const url = `${environment.apiUrl}/company/company_info`;
    const errorMessage = formatMessage(AlertMessage.FAILED_CREATE_ACTION, {
      target: this.ERR_ALERT_TARGET_NAME,
    });

    return this.httpClient
      .post(url, params, {
        headers: new HttpHeaders({
          Authorization: this.sessionInfoSingleton.getIdToken(),
          "content-type": "application/x-www-form-urlencoded",
        }),
      })
      .pipe(
        catchError((error) => {
          alert(errorMessage);
          return error;
        })
      );
  }

  /** PUT,PATCH */
  /**
   * 会社情報更新
   * - APIパス:/company/company_info/1/${companyId}
   * @param comapnyId: 会社コード
   * @param params: 更新内容
   * @returns Observable<Object>型のレスポンス
   */
  patchCompany(comapnyId: string, params: HttpParams): Observable<Object> {
    const url = `${environment.apiUrl}/company/company_info/1/${comapnyId}`;
    const errorMessage = formatMessage(AlertMessage.FAILED_UPDATE_ACTION, {
      target: this.ERR_ALERT_TARGET_NAME,
    });

    return this.httpClient
      .patch(url, params, {
        headers: new HttpHeaders({
          Authorization: this.sessionInfoSingleton.getIdToken(),
          "content-type": "application/x-www-form-urlencoded",
        }),
      })
      .pipe(
        catchError((error) => {
          alert(errorMessage);
          return error;
        })
      );
  }

  /**
   * 会社情報削除
   * - APIパス:/company/company_info/0/${companyId}
   * @param comapnyId: 会社コード
   * @param params: 更新内容
   * @returns Observable<Object>型のレスポンス
   */
  deleteCompany(comapnyId: string, params: HttpParams): Observable<Object> {
    const url = `${environment.apiUrl}/company/company_info/0/${comapnyId}`;
    const errorMessage = formatMessage(AlertMessage.FAILED_DELETE_ACTION, {
      target: this.ERR_ALERT_TARGET_NAME,
    });

    return this.httpClient
      .patch(url, params, {
        headers: new HttpHeaders({
          Authorization: this.sessionInfoSingleton.getIdToken(),
          "content-type": "application/x-www-form-urlencoded",
        }),
      })
      .pipe(
        catchError((error) => {
          alert(errorMessage);
          return error;
        })
      );
  }
}
